import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c7d965"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-4 col-xl-4" }
const _hoisted_2 = { class: "card border-hover-primary" }
const _hoisted_3 = {
  class: "card-header border-0 w-full",
  style: {"padding":"0 !important"}
}
const _hoisted_4 = { class: "card-title m-0 d-flex position-relative" }
const _hoisted_5 = { class: "position-absolute top-0 start-0 m-3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card-body px-9 py-4" }
const _hoisted_8 = { class: "fs-6 min-h-80px" }
const _hoisted_9 = {
  key: 0,
  class: "badge mb-8 px-8"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-started mb-8 px-8"
}
const _hoisted_11 = {
  key: 2,
  class: "badge mb-8 px-8 badge-success"
}
const _hoisted_12 = {
  class: "d-flex text-gray-900 justify-content-center font-poppins",
  style: {"font-size":"20px"}
}
const _hoisted_13 = {
  class: "d-flex text-gray-800 justify-content-center text-center font-poppins",
  style: {"font-size":"14px"}
}
const _hoisted_14 = { class: "d-flex justify-content-center" }
const _hoisted_15 = {
  class: "mt-4",
  style: {"width":"65%"}
}

import { computed } from "vue";
import PathwayBadges from "./PathwayBadges.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import ButtonPurple from "../buttons/ButtonPurple.vue";

interface Props {
  pathway: any;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    pathway: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: "click", id: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pathway: any;
}




const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const { t } = useI18n();

const handleClick = () => {
  emit("click", props.pathway.id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(PathwayBadges, {
              level: __props.pathway.level,
              type: __props.pathway.type,
              "percentage-completed": __props.pathway.percentage_completed
            }, null, 8, ["level", "type", "percentage-completed"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: __props.pathway.image,
              class: "avatar-img img-fluid",
              alt: "image"
            }, null, 8, _hoisted_6)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            (__props.pathway.percentage_completed == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.pathway.to_start`)), 1))
              : (__props.pathway.percentage_completed > 0 && __props.pathway.percentage_completed < 100)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.pathway.started`)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.pathway.finished`)), 1))
          ]),
          _createElementVNode("h2", _hoisted_12, _toDisplayString(__props.pathway.name), 1),
          _createElementVNode("small", _hoisted_13, _toDisplayString(__props.pathway.short_description), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(ButtonPurple, {
                size: "sm",
                text: _unref(t)(`${_unref(currentLanguage)}.pathway.watch_pathway`),
                onClick: handleClick
              }, null, 8, ["text"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})